package com.merkost.handpass.api.dto.listing

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ListingLocationDto(
    val suburb: String? = null,
    val city: String? = null,
    val state: String? = null,
    val postcode: String? = null,
    val country: String? = null,
    @SerialName("country_code") val countryCode: String? = null,
    val latitude: Double? = null,
    val longitude: Double? = null,
    @SerialName("formatted_address") val formattedAddress: String? = null,
    @SerialName("place_id") val placeId: String? = null
)
